/**
 * Counts the number of words in a string.
 * Handles edge cases: empty strings, multiple spaces, newlines.
 * 
 * @param {string} text - The text to count words in.
 * @returns {number} The number of words.
 */
export function countWords(text) {
  if (!text || typeof text !== "string") return 0;
  const trimmed = text.trim();
  if (trimmed.length === 0) return 0;
  return trimmed.split(/\s+/).length;
}

/**
 * Default maximum word limit for project text fields.
 */
export const MAX_WORD_LIMIT = 300;
